export default [
    {
        codes: [
            'CHASSIS_CAB',
            'CREW_CAB_LONG_BOX',
            'CREW_CAB_SHORT_BOX',
            'CREW_CAB',
            'DOUBLE_CAB',
            'EXTENDED_CAB_LONG_BOX',
            'EXTENDED_CAB_SHORT_BOX',
            'EXTENDED_CAB',
            'FULL_SIZE',
            'LONG_BOX',
            'MID_SIZE',
            'PICKUP',
            'QUAD_CAB',
            'REGULAR_CAB_LONG_BOX',
            'REGULAR_CAB_SHORT_BOX',
            'REGULAR_CAB',
            'SHORT_BOX',
        ],
        iconClass: 'pickup',
        group: 'PICKUP',
    },
    {
        codes: ['SEDAN'],
        iconClass: 'sedan',
        group: 'SEDAN',
    },
    {
        codes: ['COUPE'],
        iconClass: 'coupe',
        group: 'COUPE',
    },
    {
        codes: ['VAN'],
        iconClass: 'van',
        group: 'VAN',
    },
    {
        codes: ['CONVERTIBLE'],
        iconClass: 'convertible',
        group: 'CONVERTIBLE',
    },
    {
        codes: ['STATION_WAGON'],
        iconClass: 'wagon',
        group: 'STATION_WAGON',
    },
    {
        codes: ['LIMOUSINE'],
        iconClass: 'limousine',
        group: 'LIMOUSINE',
    },
    {
        codes: ['COMPACT'],
        iconClass: 'compact',
        group: 'COMPACT',
    },
    {
        codes: ['CARGO'],
        iconClass: 'cargo',
        group: 'CARGO',
    },
    {
        codes: ['PASSENGER'],
        iconClass: 'cargo',
        group: 'PASSENGER',
    },
    {
        codes: ['BOX_TRUCK', 'CUBE'],
        iconClass: 'cargo',
        group: 'CUBE',
    },
    {
        codes: ['SUV'],
        iconClass: 'suv',
        group: 'SUV',
    },
    {
        codes: ['CROSSOVER'],
        iconClass: 'suv',
        group: 'CROSSOVER',
    },
    {
        codes: ['HATCHBACK'],
        iconClass: 'hatchback',
        group: 'HATCHBACK',
    },
    {
        codes: ['MINIVAN'],
        iconClass: 'van',
        group: 'MINIVAN',
    },
    {
        codes: ['OTHER'],
        iconClass: '',
        group: 'OTHER',
    },
];



// WEBPACK FOOTER //
// ./client/src/constants/bodyStyle.js